import useHover from '~/client/hooks/events/useHover';
import SiteBridgeLink from '~/client/shared/SiteBridgeLink';
import sendInteractionToGtm from '~/shared/gtm/sendInteractionToGtm';
import sendEventToUmami from '~/shared/trackEvent/sendEventToUmami';
import ExtendedTitle from './ExtendedTitle';
import Title from './Title';
import SidebarIcon from '../SidebarIcon';

type Props = {
  link: string;
  target?: '_blank';
  icon: string;
  iconExt?: '.svg' | '.png' | '.jpg';
  text: string;
  description?: string;
  descriptionColor?: string;
  externalLink?: boolean;
};

const SidebarItem: FC<Props> = ({
  link,
  text,
  children,
  target,
  description,
  descriptionColor,
  icon,
  iconExt,
}) => {
  const { hoverRef, isHovered } = useHover<HTMLAnchorElement>();
  return (
    <div
      onClick={() => {
        sendEventToUmami(
          {
            menu: link,
          },
          'desktopSideMenuClick',
        );

        sendInteractionToGtm({
          eventCategory: 'Menu_item',
          eventAction: 'sidebar_menu',
        });
      }}
    >
      <SiteBridgeLink
        className="grid max-w-[12rem] grid-flow-col items-center justify-between gap-1 [&_p]:duration-200"
        href={link}
        target={target}
        innerRef={hoverRef}
      >
        <>
          <div className="grid grid-flow-col grid-cols-[minmax(2rem,1fr)] items-center gap-3">
            <SidebarIcon icon={icon} isHovered={isHovered} iconExt={iconExt} />
            {description ? (
              <ExtendedTitle
                text={text}
                description={description}
                descriptionColor={descriptionColor || 'text-bulma'}
                isHovered={isHovered}
              />
            ) : (
              <Title isHovered={isHovered} text={text} />
            )}
          </div>
          <p className="text-moon-14 text-trunks">{children}</p>
        </>
      </SiteBridgeLink>
    </div>
  );
};

export default SidebarItem;
